<p class="mat-body-2">
  <span class="mat-subtitle-2">{{ description }}</span>
</p>